/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Online_Pending_DesktopInputs */

const en_fc_online_pending_desktop = /** @type {(inputs: Fc_Online_Pending_DesktopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get the desktop app`)
};

/**
* | output |
* | --- |
* | "Get the desktop app" |
*
* @param {Fc_Online_Pending_DesktopInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_online_pending_desktop = /** @type {((inputs?: Fc_Online_Pending_DesktopInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Online_Pending_DesktopInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_online_pending_desktop(inputs)
});
export { fc_online_pending_desktop as "fc.online.pending.desktop" }